module.exports = __webpack_public_path__ + "img/click@2x.96287661.png";